<template>
    <div class="paopaotui-sheet sheet" @click.stop="onClose">
        <div class="main" :class="{close: isClose}" @click.stop>
            <div class="header">
                <div class="cancel" @click="onCancel">
                    <span v-show="!noBtn">取消</span>
                </div>
                <div class="title">
                    {{ title }}
                </div>
                <div class="confirm" @click="onConfirm">
                    <span v-show="!noBtn">確定</span>
                </div>
            </div>
            <div class="description">{{ description }}</div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BottomSheet',
        props: {
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                default: '',
            },
            noBtn: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isClose: true,
            };
        },
        methods: {
            onConfirm(e) {
                this.$emit('onConfirm', e)
            },
            onCancel(e) {
                this.$emit('onCancel', e);
            },
            onClose(e) {
                this.isClose = true;
                this.$emit('onClose', e);
            }
        },
        mounted() {
            setTimeout(() => {
                this.isClose = false;
            }, 50);
        }
    };
</script>

<style lang="scss" scoped>
    .sheet {
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
    }

    .main {
        border-radius: 10px 10px 0 0;
        background-color: rgba(255,255,255,1);
        padding: 25px 15px;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        bottom: 0;
        left: 0;
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        max-height: 90vh;

        &.close {
            bottom: -100%;
        }

        .header {
            display: flex;
            justify-content: space-between;
            margin: 0 5px;
            font-size: 16px;
            line-height: 22px;

            .cancel {
                color: rgba(155,155,155,1);
                cursor: pointer;
            }

            .confirm {
                color: rgba(51,153,51,1);
                cursor: pointer;
            }

            .title {
                color: rgba(0,0,0,1);
                font-weight: 500;
            }
        }

        .content {
            margin-top: 20px;
        }

        .description {
            color: rgba(120,120,120,1);
            font-size: 12px;
            line-height: 17px;
            text-align: center;
        }
    }
</style>
